import React from "react";
import { t } from "../i18n";
import { ClockCounterClockwise, Trash } from "@phosphor-icons/react";

function scoreColor(score) {
  if (score >= 85) return "text-emerald-700 border-emerald-600";
  if (score >= 70) return "text-amber-700 border-amber-600";
  if (score >= 50) return "text-orange-700 border-orange-600";
  return "text-red-700 border-red-600";
}

export default function HistorySidebar({ items, onSelect, onDelete, activeId, lang }) {
  return (
    <aside
      className="w-full lg:w-[320px] shrink-0 border-r border-neutral-900 bg-white flex flex-col"
      data-testid="history-sidebar"
    >
      <div className="flex items-center gap-2 px-4 py-4 border-b border-neutral-900">
        <ClockCounterClockwise size={16} />
        <div className="text-xs uppercase tracking-[0.2em] font-mono">
          {t(lang, "history")}
        </div>
        <span className="ml-auto text-[10px] font-mono text-neutral-500">
          {items.length}
        </span>
      </div>
      <div className="flex-1 overflow-y-auto ma-scroll">
        {items.length === 0 ? (
          <div
            className="p-4 text-xs font-mono text-neutral-500"
            data-testid="history-empty"
          >
            {t(lang, "no_history")}
          </div>
        ) : (
          <ul>
            {items.map((it) => {
              const isActive = activeId === it.id;
              const sc = scoreColor(it.compliance_score);
              return (
                <li
                  key={it.id}
                  className={`border-b border-neutral-200 ma-trans ${
                    isActive ? "bg-neutral-900 text-white" : "hover:bg-neutral-50"
                  }`}
                  data-testid={`history-item-${it.id}`}
                >
                  <div className="flex">
                    <button
                      type="button"
                      onClick={() => onSelect(it.id)}
                      className="flex-1 text-left px-3 py-3 min-w-0"
                      data-testid={`history-select-${it.id}`}
                    >
                      <div className="flex items-center gap-2 mb-1">
                        <span
                          className={`inline-flex items-center justify-center w-9 h-6 text-[11px] font-mono border ${
                            isActive ? "text-white border-white" : sc
                          }`}
                        >
                          {it.compliance_score}
                        </span>
                        <span
                          className={`text-[10px] uppercase tracking-widest font-mono ${
                            isActive ? "text-neutral-300" : "text-neutral-500"
                          }`}
                        >
                          {it.page_type}
                        </span>
                      </div>
                      <div
                        className={`text-xs font-mono truncate ${
                          isActive ? "text-white" : "text-neutral-800"
                        }`}
                        title={it.source}
                      >
                        {it.source}
                      </div>
                      <div
                        className={`text-[10px] font-mono mt-1 ${
                          isActive ? "text-neutral-400" : "text-neutral-500"
                        }`}
                      >
                        {new Date(it.created_at).toLocaleString()} · {it.violations_count} issues
                      </div>
                    </button>
                    <button
                      type="button"
                      onClick={() => onDelete(it.id)}
                      className={`px-3 border-l ${
                        isActive
                          ? "border-neutral-700 text-neutral-300 hover:text-white"
                          : "border-neutral-200 text-neutral-500 hover:text-red-700"
                      } ma-trans`}
                      aria-label="delete"
                      data-testid={`history-delete-${it.id}`}
                    >
                      <Trash size={14} />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </aside>
  );
}
